import React                          from "react";
// import {Route, Routes} from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactGA                        from 'react-ga';
import { createBrowserHistory }       from 'history';
import 'react-router';
import './App.css';

import Top              from './pages/Top';
import Login            from './pages/Login';
import FamilyHome       from './pages/FamilyHome';
import Invitation       from './pages/Invitation';
import InvitationAccept from './pages/InvitationAccept';
import Invalid          from './pages/Invalid';
import PersonalHome     from './pages/PersonalHome';
import FamilyRegist     from "./pages/FamilyRegist";
import SymptomCard      from './pages/SymptomCard';
import DemoTop          from './pages/DemoTop';

import 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import InvitationList from "./pages/invitationList";

const trackingId = "G-0BB720GHS0"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId, {
  gaOptions: {
    cookieFlags: 'SameSite=None;Secure'
  }
});
const history = createBrowserHistory();
history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

export default function App() {
  
  return (
    /* <Router history={history}> */
    <React.Fragment>
      <div style={{minHeight: '100vh', maxWidth: '480px'}} className="App">
        <BrowserRouter>
          <Routes>
            <Route path='/'                             exact element={<Top />} />              {/* サイト表示時はTopでログインチェックする。 */}
            <Route path='/Login'                        exact element={<Login />} />            {/* ログイン画面 */}
            <Route path='/FamilyHome/:FamilyID'         exact element={<FamilyHome />} />       {/* 家族ホーム画面 */}
            <Route path='/Invitation'                   exact element={<Invitation />} />       {/* 家族招待画面 */}
            <Route path='/Invitation/:FamilyID'         exact element={<Invitation />} />       {/* 家族招待画面 */}
            <Route path='/InvitationList'               exact element={<InvitationList />} />       {/* 家族招待画面 */}
            <Route path='/InvitationList/:FamilyID'     exact element={<InvitationList />} />       {/* 家族招待画面 */}
            <Route path='/InvitationAccept'             exact element={<InvitationAccept />} />     {/* 家族招待受け画面 - InvitationID=(InvitationID) の形式でアクセス */}
            <Route path='/Invalid'                      exact element={<Invalid />} />          {/* 無効URL画面 */}
            <Route path='/familyregist'                 exact element={<FamilyRegist />} />     {/* 家族登録画面 */}
            <Route path='/PersonalHome/:MemberID'       exact element={<PersonalHome />} />     {/* 個人ホーム画面 */}
            <Route path='/SymptomCard/:MedicalRecordID' exact element={<SymptomCard />} />      {/* 症状カード画面 */}
            <Route path='/FamilyHome/'                  exact element={<Top />} />              {/* Topでログインチェックする。 */}
            <Route path='/PersonalHome/'                exact element={<Top />} />              {/* Topでログインチェックする。 */}
            <Route path='/SymptomCard/'                 exact element={<Top />} />              {/* Topでログインチェックする。 */}
            <Route path='/Demo'                         exact element={<DemoTop />} />          {/* デモ画面トップ */}
            <Route element={<Top />} /> {/* URLが不一致の場合はTopでログインチェックする */}
          </Routes>
        </BrowserRouter>
      </div>
    </React.Fragment>
  )
}

// export default App;
